function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

function PlugableControlBase() {
  this.OnChange = function (vueInstance) {
    this.$emit("change", this.GetControlXml());

    if (this.$parent != null && this.$parent.OnChildControlChange != null) {
      this.$parent.OnChildControlChange(vueInstance);
    }
  };

  this.ConvertObjectToXml = function (dataObject, tagName) {
    var dataXml = "";
    var contentXml = "";
    var beginTag, endTag;
    var childTagName;
    var sourcePropertyName;
    var propertyNameAttributeParameter = "";
    var i, j;

    if (tagName.match(/[A-Z]+/) != null) {
      propertyNameAttributeParameter = " PropertyName=\"".concat(tagName, "\" ");
    }

    if (dataObject != null && _typeof(dataObject) == "object" && Array.isArray(dataObject)) {
      beginTag = "    <".concat(tagName, " Type=\"Array\" ").concat(propertyNameAttributeParameter, ">\n");
      endTag = "    </".concat(tagName, ">\n");
    } else if (dataObject != null && _typeof(dataObject) == "object" && !Array.isArray(dataObject)) {
      beginTag = "    <".concat(tagName, " Type=\"Object\" ").concat(propertyNameAttributeParameter, ">\n");
      endTag = "    </".concat(tagName, ">\n");
    } else {
      if (typeof dataObject == "boolean") {
        beginTag = "    <".concat(tagName, " Type=\"Boolean\" ").concat(propertyNameAttributeParameter, ">");
      } else if (typeof dataObject == "number") {
        beginTag = "    <".concat(tagName, " Type=\"Number\" ").concat(propertyNameAttributeParameter, ">");
      } else {
        beginTag = "    <".concat(tagName, ">");
      }

      endTag = "</".concat(tagName, ">\n");
    }

    if (_typeof(dataObject) == "object" && !Array.isArray(dataObject)) {
      for (i in dataObject) {
        if (i != "ControlId" && i != "ControlType") {
          if (i.indexOf("$NotCommitted") > 0) {
            sourcePropertyName = i.replace("$NotCommitted", "");
            dataObject[sourcePropertyName] = dataObject[i];
            delete dataObject[i];
          }
        }
      }

      for (i in dataObject) {
        if (i != "ControlId" && i != "ControlType" && i.indexOf("m_") != 0) {
          contentXml += "    " + this.ConvertObjectToXml(dataObject[i], i) + "\r\n";
        }
      }
    } else if (dataObject != null && Array.isArray(dataObject)) {
      for (i = 0; i < dataObject.length; i++) {
        childTagName = tagName.replace("list", "");
        contentXml += "    " + this.ConvertObjectToXml(dataObject[i], childTagName) + "\r\n";
      }
    } else {
      if (dataObject != null) {
        contentXml += dataObject;
      }
    }

    if (tagName == "props" && contentXml.trim() == "") {
      dataXml = "";
    } else if (contentXml != "") {
      dataXml = beginTag + contentXml + endTag;
    } //if (dataXml.indexOf(`type="Array"`) >= 0) {
    //    debugger;
    //}


    return dataXml;
  };

  this.GetControlXml = function () {
    var controlXml = "";
    var dataXml;
    var propsXml;
    controlXml = "\n    <control Type=\"".concat(this.ControlType, "\" >\n");

    if (this.$props != null) {
      propsXml = this.ConvertObjectToXml(this.$props, "props");
      controlXml += propsXml;
    }

    dataXml = this.ConvertObjectToXml(this.$data, "data");
    controlXml += dataXml;
    controlXml += "\n    </control>\n";
    return controlXml;
  };
}

PlugableControlBase.ElementSerialNo = 1;
export default PlugableControlBase;